import axios from 'axios';
import config from '@/config';
import * as constants from '../constants';

const { endpoints } = config.page;

const fetchPages = ({ dispatch, commit }) => (
  new Promise((resolve, reject) => {
    axios({ url: endpoints.pages })
      .then((resp) => {
        commit(constants.PAGE_PAGES, resp.data);
        resolve(resp.data);
      })
      .catch((err) => {
        dispatch('core/showGeneralError', { err }, { root: true });
        reject(err);
      });
  })
);

export default {
  fetchPages,
};
